// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".addStructBtnContainer--22t-Nwwj {\n  display: inline-block;\n}\n\n.formItem--188Xuuep {\n  margin: 10px 0;\n}\n\n.formLabel--3YZz_SMn {\n  display: block;\n}\n\n.structTableTd--2qR2PlWs {\n  padding: 8px 16px !important;\n}\n\n.structTableTd--2qR2PlWs {\n  word-break: break-all;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addStructBtnContainer": "addStructBtnContainer--22t-Nwwj",
	"formItem": "formItem--188Xuuep",
	"formLabel": "formLabel--3YZz_SMn",
	"structTableTd": "structTableTd--2qR2PlWs"
};
export default ___CSS_LOADER_EXPORT___;
